import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { NotificationForm } from 'page-components/notifications/NotificationForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const Notification = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.notificationsCreate ? 'create_notification' : 'edit_notification';
  const titleText = pathname.includes('view') ? 'view_notification' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <NotificationForm />
    </PageLayout>
  );
};
